module.exports = __webpack_public_path__ + "static/media/Shockoe-Logo-Desktop.d1f17224.png";